angular
    .module('MyApp')
    .service('AssistenciaEstudantilService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.listarAssistencias = function(codAluno){
        let deferr = $q.defer();
         if (codAluno) {
            $resource(Configs.getApiServer() + '/edital/assistencias?cod-aluno=:codAluno',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codAluno
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.obterTermoCompromisso = function(idEdital, idAssistencia){
        let deferr = $q.defer();
         if (idEdital && idAssistencia) {
            $resource(Configs.getApiServer() + '/edital/termo-compromisso-assistencia?id-edital=:idEdital&id-assistencia=:idAssistencia',
                {}, { 'query': { method: 'GET', isArray: false } }).query({
                  idEdital, idAssistencia
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.listarAssistenciasDocs = function(idAssistencia){
        let deferr = $q.defer();
         if (idAssistencia) {
            $resource(Configs.getApiServer() + '/edital/documentos-assistencia?id-assistencia=:idAssistencia',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idAssistencia
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.listarRelatorios = function(idAssistencia){
        let deferr = $q.defer();
         if (idAssistencia) {
            $resource(Configs.getApiServer() + '/edital/relatorios?id-assistencia=:idAssistencia',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idAssistencia
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.obterTermo = function(idAssistencia){
        let deferr = $q.defer();
         if (idAssistencia) {
            $resource(Configs.getApiServer() + '/edital/termo?id-assistencia=:idAssistencia',
                {}, { 'query': { method: 'GET', isArray: false } }).query({
                  idAssistencia
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.solicitarRecursoAssistencia = function(recursoAssistenciaDTO) {
        let deferr = $q.defer();
        if (recursoAssistenciaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/recurso-assistencia", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(recursoAssistenciaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

      this.aceitarTermoCompromissoAssistencia = function(termoAssistenciaDTO) {
        console.log('termoAssistenciaDTO', termoAssistenciaDTO);
        let deferr = $q.defer();
        if (termoAssistenciaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/aceita-termo-compromisso-assistencia", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(termoAssistenciaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

      this.listarProcDocumentos = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/documentos-processo',
                {}, { 'query': { method: 'GET', isArray: true } }).query({

                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.incluirDocumentoAssistencia = function(docAssistenciaDTO) {
        let deferr = $q.defer();
        if (docAssistenciaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/incluir-documento-assistencia", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(docAssistenciaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

    }]);
